export const REPEAT_ENGAGEMENT_CHART_OPTIONS = {
    chart: {
        id: 'chart1',
        type: 'bar',
        stacked: true,
        toolbar: { show: false }
    },
    colors: ['#FEC84B','#6CE9A6','#9EA5D1','#FAA7E0','#7CD4FD', '#84CAFF','#FEB273','#FEA3B4','#A4BCFD','#BDB4FE','#667085','#F79009','#12B76A','#4E5BA6','#0BA5EC','#EE46BC','#2E90FA','#F63D68','#7A5AF8','#FB6514','#6172F3'],
    noData: {
        text: 'No data to show.',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    legend: { 
        show: false,
        position: 'top',
        horizontalAlign: 'right',
        showForSingleSeries: true, 
        markers: {
            width: 8,
            height: 8,
            radius: 8
        }
    },
    xaxis: {
        title: {
            text: 'Months',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: {
            style: {
                colors: Array.from({ length: 20 })?.map(()=> '#667085'),
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label'
            }
        },
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'Engagements',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        }
    },
    grid: { show: false },
    plotOptions: {
        bar: {
            columnWidth: '50%',
            borderRadius: 2
        }
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    dataLabels: { enabled: false }
};